import { render, staticRenderFns } from "./TraitsPanel.vue?vue&type=template&id=1948f632"
import script from "./TraitsPanel.vue?vue&type=script&lang=js"
export * from "./TraitsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports